import { gql } from '@apollo/client';

export const MY_FEATURE_FLAGS = gql`
  query myFeatureFlags {
    myFeatureFlags
  }
`;
